// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COLORS = "Barvy";
export const PRICE = "Cena";
export const RATING = "RATING";
export const STROLLER_counter_REVIEWS = ["%(counter)s hodnocen\u00ed", "%(counter)s hodnocen\u00ed", "%(counter)s hodnocen\u00ed"];
export const STROLLERS_COMPARISON = "Porovnej";
export const STROLLERS_COMPARISON__SHOW_VARIOUS = "Zobraz jen rozd\u00edln\u00e9 parametry";
export const STROLLERS_COMPARISON__SHOW_VARIOUS_OR_SAME = "Zobraz i shodn\u00e9 parametry";
export const STROLLER_STROLLEROPEDIA = "Ko\u010d\u00e1rkopedie";
export const STROLLER_UNPREPARED_TAG = "P\u0159ipravujeme";
export const WIKI_REVIEWS = "Centrum recenz\u00ed";
